var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 447.6 323.3",
    style: {
      enableBackground: "new 0 0 447.6 323.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#522B79;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000154391895545473408810000006277976515298805156_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "365.2,0 325.7,12.5 358.9,38.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "415.1,34.2 412.1,75.9 445.1,57.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "404.7,74 407.8,30.8 369,46.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "372.7,1.2 366.4,39.2 402.8,24.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.7,86.7l-54.2,29.6c-1.5-1.4-3.1-2.9-4.8-4.2l52.9-30.2L363,51.1l-19.2,56.4c-1.9-1.4-3.9-2.9-5.8-4.2 l18.9-57L321,18.5l12,82c-42-24.5-94.8-21.2-133.3,8.5c5.5,4.7,10.6,9.8,15.3,15.3c43.8-32,105.2-22.4,137.2,21.5 S374.5,251,330.7,283c-34.5,25.2-81.3,25.2-115.7,0c-0.8-0.6-1.7-1.1-2.5-1.8c-0.4-0.3-0.7-0.6-1-0.9c-5.6-4.5-10.7-9.6-15.2-15.2 c-0.9-1.2-1.9-2.4-2.8-3.6c-25-34.4-25-81,0-115.4c-4.5-5.7-9.6-10.9-15.2-15.5c-33.3,43.1-33.3,103.3,0,146.4 c0.9,1.1,1.8,2.3,2.8,3.4c4.6,5.5,9.7,10.6,15.3,15.2c1,0.8,2,1.7,3.1,2.5l0.5,0.3c52.3,40.3,127.4,30.6,167.7-21.8 c36.4-47.3,32.4-114.2-9.4-156.7l82.4-8.4L408.7,86.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "415.7,82.6 445.2,105.6 447.6,64.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.4,283c-43.8,32-105.2,22.4-137.2-21.4S17.8,156.4,61.6,124.4c34.5-25.2,81.3-25.2,115.8,0 c0.8,0.6,1.7,1.1,2.5,1.8c0.4,0.3,0.7,0.6,1,0.9c5.6,4.5,10.7,9.6,15.2,15.2c0.9,1.2,1.9,2.4,2.8,3.6c25,34.4,25,81,0,115.4 c4.5,5.7,9.6,10.9,15.2,15.5c33.3-43.1,33.3-103.2,0-146.3c-0.9-1.1-1.8-2.3-2.8-3.4c-4.6-5.5-9.7-10.6-15.3-15.2 c-1-0.8-2-1.7-3.1-2.5l-0.4-0.3C140.3,68.6,65.2,78.3,24.9,130.6S-5.8,258,46.5,298.4c43,33.2,103,33.2,146.1,0 C187.1,293.7,182,288.6,177.4,283z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/Ring.83bef44648859f2ddb0d58b0f270c69b.svg";
export { ForwardRef as ReactComponent };